import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { MoveHorizontal } from 'lucide-react';
export function BeforeAfter() {
  const [sliderPosition, setSliderPosition] = useState(50);
  const [isDragging, setIsDragging] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const handleMove = (clientX: number) => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const x = Math.max(0, Math.min(clientX - rect.left, rect.width));
    const percent = x / rect.width * 100;
    setSliderPosition(percent);
  };
  const onMouseMove = (e: MouseEvent) => {
    if (!isDragging) return;
    handleMove(e.clientX);
  };
  const onTouchMove = (e: TouchEvent) => {
    if (!isDragging) return;
    handleMove(e.touches[0].clientX);
  };
  useEffect(() => {
    if (isDragging) {
      window.addEventListener('mousemove', onMouseMove);
      window.addEventListener('mouseup', () => setIsDragging(false));
      window.addEventListener('touchmove', onTouchMove, {
        passive: false
      });
      window.addEventListener('touchend', () => setIsDragging(false));
    }
    return () => {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', () => setIsDragging(false));
      window.removeEventListener('touchmove', onTouchMove);
      window.removeEventListener('touchend', () => setIsDragging(false));
    };
  }, [isDragging]);
  return <section id="gallery" className="py-20 md:py-28 bg-brand-cream" data-id="element-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-16">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-display text-4xl md:text-5xl font-bold text-brand-brown mb-6" data-id="element-17">
            See the Transformation
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-brand-brown/80" data-id="element-18">
            Real Arizona homes, refreshed and protected by Hatch Painting.
          </motion.p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative w-full max-w-5xl mx-auto aspect-[4/3] md:aspect-[16/9] rounded-xl overflow-hidden shadow-2xl select-none" ref={containerRef} onMouseDown={e => {
        setIsDragging(true);
        handleMove(e.clientX);
      }} onTouchStart={e => {
        setIsDragging(true);
        handleMove(e.touches[0].clientX);
      }} data-id="element-19">
          {/* After Image (Base) */}
          <img src="https://cdn.magicpatterns.com/uploads/4VTmZFEqCbFaZpbBYAZwcJ/hatch-after.jpg" alt="After painting" className="absolute inset-0 w-full h-full object-cover pointer-events-none" data-id="element-20" />
          <div className="absolute top-4 right-4 bg-brand-brown/80 text-brand-cream px-3 py-1 rounded text-sm font-medium backdrop-blur-sm" data-id="element-21">
            After
          </div>

          {/* Before Image (Clipped) */}
          <div className="absolute inset-0 w-full h-full overflow-hidden pointer-events-none" style={{
          clipPath: `inset(0 ${100 - sliderPosition}% 0 0)`
        }} data-id="element-22">
            <img src="https://cdn.magicpatterns.com/uploads/9ZYJoCuiyWCciRsPcmMizu/hatch-before.jpg" alt="Before painting" className="absolute inset-0 w-full h-full object-cover" data-id="element-23" />
            <div className="absolute top-4 left-4 bg-brand-cream/90 text-brand-brown px-3 py-1 rounded text-sm font-medium backdrop-blur-sm" data-id="element-24">
              Before
            </div>
          </div>

          {/* Slider Handle */}
          <div className="absolute top-0 bottom-0 w-1 bg-brand-cream cursor-ew-resize" style={{
          left: `${sliderPosition}%`,
          transform: 'translateX(-50%)'
        }} data-id="element-25">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 bg-brand-orange rounded-full flex items-center justify-center shadow-lg border-2 border-brand-cream" data-id="element-26">
              <MoveHorizontal className="w-5 h-5 text-brand-cream" data-id="element-27" />
            </div>
          </div>
        </motion.div>

        <div className="text-center mt-12" data-id="element-28">
          <a href="#gallery" className="inline-flex justify-center items-center px-8 py-4 text-lg font-medium rounded border-2 border-brand-orange text-brand-orange hover:bg-brand-orange hover:text-brand-cream transition-all min-h-[48px]" data-id="element-29">
            See Our Full Gallery
          </a>
        </div>
      </div>
    </section>;
}